import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import { getUnits } from 'utils/unit';

export const NAME =
  'compositions_DealerLocator_LocationWeather_locationWeatherQuery';

const query = gql`
  query ${NAME} (
    $location: Position!,
    $temperatureUnit: TemperatureUnit,
    $windSpeedUnit: WindSpeedUnit,
  ) {
    locationWeather (
      location: $location,
    ) {
      current {
        code
        temperature(unit: $temperatureUnit)
        summary
        windBearing
        windSpeed(unit: $windSpeedUnit)
      }
      today {
        precipProbability
        precipType
        temperatureLow(unit: $temperatureUnit)
        temperatureHigh(unit: $temperatureUnit)
      }
      hourly {
        summary
        temperature(unit: $temperatureUnit)
        time
        code
      }
      timezone
    }
  }
`;

export function buildOptions({ location, unit }) {
  const units = getUnits(unit);

  return {
    variables: {
      location,
      temperatureUnit: units.temperatureUnitValue,
      windSpeedUnit: units.windSpeedUnitValue,
    },
  };
}

export function mapProps({ [NAME]: { locationWeather: weather, ...rest } }) {
  return {
    weather,
    ...rest,
  };
}

export function skipQuery(props) {
  return !props.location || !props.unit;
}

const config = {
  name: NAME,
  options: buildOptions,
  props: mapProps,
  skip: skipQuery,
};

export default graphql(query, config);



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/SearchInput/LocationTimeAndWeather/locationWeatherQuery.js